(function() {

window.w = window;
w.d = document;
w.ui = {};
w.ui.langCode = 'ru';
w.ui.lang = {
"bank_account_description":"После оформления заказа менеджер высылает счет-фактуру для оплаты",
"bank_account_title":"Оплата на рассчетный счет",
"button_1click_short":"В 1 клик",
"button_checkout":"Оформление заказа",
"button_checkout1":"Оформить в 1 клик",
"button_continue_select":"Продолжить выбор",
"button_delete":"Удалить",
"button_delete_all":"Очистить",
"button_shopping":"Продолжить покупки",
"chat_message":"Напишите нам!",
"cod_description":"",
"cod_title":"Оплата при получении",
"info_24h_shipping_modal_description":"<p>Заказы принимаются через сайт 24/7, также вы можете позвонить нашим менеджерам и оформить заказ по телефону <a class=\"email binct-phone-number-1\" href=\"tel:0 800 335 348\" aria-label=\"telephone\" rel=\"noopener noreferrer nofollow\">0 800 335 348</a> в будни с 09:00 до 18:00.</p>\n<p>Заказы отправляются в течение 24 часов с момента подтверждения. Неподтвержденные заказы не высылаются. Подтверждением считается согласование заказа в телефонном режиме или по электронной почте. Автоматически подтверждаются заказы, в которых указаны все необходимые для отправки данные.</p>\n<p>Уважаемый покупатель! Пожалуйста, обратите внимание: отправление товаров осуществляется по будням в 12:00. То есть, если вы хотите, чтобы заказ поехал к вам сегодня, он должен быть сформирован, подтвержден и оплачен (в случае выбора предоплаты на расчетный счет) к этому времени.</p>",
"info_24h_shipping_modal_title":"Отправляем в течении 24 часов",
"info_guarantee_and_service_modal_description":"<p><b>Условия гарантийного обслуживания:</b></p>\n<ul>\n <li>Срок действия гарантии на товар - от 24 до 60 месяцев. Гарантийный срок начинается с момента доставки и получения Покупателем товара в место назначения в соответствии с заказом.</li>\n <li>Для гарантийного обслуживания необходимо подтверждение покупки в нашем интернет-магазине (все отправленные заказы фиксируются в нашей базе со всей сопутствующей информацией), и наличие товарного чека или товарно-транспортной накладной, выданной компанией-перевозчиком при получении заказа.</li>\n <li>Гарантийное обслуживание включает в себя проведение ремонтных работ и замену дефектных частей товара. Срок гарантии в таком случае не продлевается на время нахождения изделия в ремонте.</li>\n <li>Претензии по внешнему виду товара, механическим повреждениям, некомплекту, а также несоответствию заказа принимаются непосредственно при получении товара. В дальнейшем такие претензии не рассматриваются, все работы осуществляются только за счет Покупателя.</li>\n <li>Гарантия действует только на территории Украины.</li>\n <li>Гарантия не распространяется на расходные материалы (подшипники, ремни, кабели, резиновые элементы, грипсы, педали), в случае если прошло больше 14 дней с момента покупки.</li>\n <li>Рекомендуем отключать блоки питания электро тренажеров от электросети во время отсутствия электроснабжения, или использовать стабилизатор напряжения. Производитель не несет ответственности за последствия перепадов напряжения, которые могут привести к повреждению блоков питания и систем тренажера. В случае выявления таких повреждений сервисное обслуживание предоставляется на платной основе</li>\n</ul>\n<p><b>Гарантийное обслуживание не производится в случае:</b></p>\n<ul>\n <li>Истечения гарантийного срока.</li>\n <li>Отсутствия информации о покупке в базе данных нашего магазина или документов, подтверждающих покупку (гарантийный талон).</li>\n <li>Возникновения механических и иных повреждений (сколы, царапины, трещины в результате удара, падения или чрезмерной нагрузки).</li>\n <li>Появления следов коррозии на металлических деталях в результате повреждения лако-красочного покрытия.</li>\n <li>Возникновения повреждений или утери изделия, вызванных действиями непреодолимой силы (стихийные бедствия, пожары, наводнения и т.п.).</li>\n <li>Появления повреждений в результате небрежного отношения (несоблюдение температурного режима и режима влажности, превышение максимально допустимой нагрузки, использование некачественных средств по уходу и чистке).</li>\n <li>Использования товара в коммерческих целях и/или не в домашних условиях.</li>\n <li>Естественного износа, который можно ожидать в случае активного использования продукта (выгорание тканей, загрязнение, потертости).</li>\n</ul>\n<p><b>Условия сдачи товара в ремонт:</b></p>\n<p>При пересылке товара на гарантийный ремонт или обслуживание, товар должен направляться в разобранном виде, в оригинальной упаковке, с сохранением всех элементов, инструкции, надежно упакованным, чтобы обезопасить товар от повреждения. Без обрешетки или паллетирования.</p>\n<p>Стоимость доставки на гарантийное обслуживание оплачивает клиент, и после выявления причины поломки, и признания случая гарантийным - мы компенсируем Покупателю стоимость пересылки к нам. В случае признания случая не гарантийным - все расходы, связанные с транспортировкой и ремонтом оплачивает покупатель.</p>\n<p><b>Обмен и возврат товара:</b></p>\n<p>Вы имеете право обменять или вернуть купленный у нас товар в течение 14 дней при соблюдении следующих условий:</p>\n<ul>\n <li>- товар не использовался, не был в сборке (монтаже)</li>\n <li>- сохранен товарный вид</li>\n <li>- сохранена оригинальная упаковка товара и все ее компоненты</li>\n <li>- сохранена комплектация товара</li>\n</ul>\n<p><b>Внимание!</b> Доставка в случае обмена товара надлежащего качества или его возврат осуществляется покупателем за свой счет.</p>",
"info_guarantee_and_service_modal_title":"Гарантия и сервис",
"text_action_to":"Акция до",
"text_agree_cart":"Подтверждая заказ, вы согласшаетесь с правилами <a href=\"/ru/oplata-i-kreditovanie\" target=\"_blank\">покупки</a>, <a href=\"/ru/dostavka-i-vozvrat-tovara\" target=\"_blank\">доставки и возврата</a>",
"text_app_btn":"Установить приложение",
"text_apply":"Применить",
"text_area":"обл.",
"text_button":"Оформить",
"text_cart":"Корзина",
"text_cart_empty":"Ваша корзина пуста",
"text_cashback_accept":"Принять условия",
"text_cashback_brand":"Besport Bonus",
"text_cashback_col_orders":"Сумма заказа",
"text_cashback_col_photo":"Фото / Отзыв",
"text_cashback_col_video":"Видеообзор",
"text_cashback_intro":"Поделитесь впечатлениями в Instagram или Tik Tok и получите до 1200 грн на карту.",
"text_cashback_note_1":"Если в заказе больше 1 товара — кешбек считается на общую сумму при условии обзоров на <span class=\"underline decoration-yellow-400 decoration-2\">каждый</span> товар.",
"text_cashback_note_2":"Кешбек не суммируется и не переносится на будущие покупки.",
"text_cashback_special_label":"Спецпредложение",
"text_cashback_special_title":"Кешбек удваивается!",
"text_cashback_step_1":"Подпишитесь на наш профиль в Instagram или Tik Tok",
"text_cashback_step_2":"Сделайте фото или видеообзор с купленным товаром",
"text_cashback_step_3":"Отметьте нашу страницу в посте или сторис",
"text_cashback_steps":"Что нужно сделать",
"text_cashback_tier_1":"до 5 000 грн",
"text_cashback_tier_2":"5 001 – 10 000 грн",
"text_cashback_tier_3":"10 001 – 15 000 грн",
"text_cashback_tier_4":"15 001 – 20 000 грн",
"text_cashback_tier_5":"от 20 001 грн",
"text_cashback_title":"Получите кешбек",
"text_cashback_title_accent":"за ваш отзыв!",
"text_cashback_video_eq":"Видеообзор =",
"text_cashback_video_x2":"x2 БОНУС",
"text_chat":"Чат",
"text_chat_greetings":"Здравствуйте. Есть вопросы?<br>Мы готовы вам помочь",
"text_chat_new_messages":"новые сообщения",
"text_chat_not_working_time":"Здравствуйте, к сожалению, пока нерабочее время. У менеджера нет возможности принять участие в разговоре. Мы всегда рады помочь с 9:00-18:00 с Пн-Пт",
"text_chat_server_disconnected":"Извините сейчас наш сервер чата не работает. Попробуйте через несколько минут",
"text_chat_typing":"пишет",
"text_close":"Закрыть",
"text_comment":"Комментарий",
"text_currency_unit":"грн",
"text_day":"день",
"text_day2":"дня",
"text_day5":"дней",
"text_description":"Для уточнения Вашего кредитного лимита отправьте смс<br> с текстом \"CHAST\" на номер {sms} или позвоните на {tel}<br>* Кредит оформляется на вышеуказанную безналичную стоимость товара",
"text_done":"Готово",
"text_email":"EMail",
"text_enter_message":"Написать сообщение",
"text_fail_text":"Если у Вас возникли вопросы, пожалуйста свяжитесь с нами. Можете попробовать другие типы оплат",
"text_fail_title":"Оплата вашего заказа #order_id не успешна",
"text_filter":"Фильтровать",
"text_filter_clear":"Очистить фильтр",
"text_filters":"Фильтры",
"text_found":"Найдено",
"text_from":"с",
"text_home":"Главная",
"text_hotline":"Горячая линия",
"text_in_cart":"В корзине",
"text_input_required":"Не заполнено",
"text_instock":"Есть в наличии",
"text_label_quantity_few":"Заканчивается",
"text_manager":"Менеджер YorkFitness",
"text_manager_message_cart":"Перезвоним за 5 минут для уточнения адреса доставки",
"text_month_short":"мес",
"text_months":"Месяцев",
"text_name":"Имя",
"text_no_products_in_cart":"Добавте товары в корзину",
"text_not_in_stock_btn":"Ожидаем поставки",
"text_notify_button":"Уведомить",
"text_notify_me":"Уведомить, когда доступно",
"text_offer_agree":"Нажимая на кнопку, вы соглашаетесь с правилами",
"text_offers_text":"Мы подобрали для вас похожие товары",
"text_offers_title":"Извините, этот товар отсутствует на складе",
"text_or":"или",
"text_payments":"Платежей",
"text_phone_error":"Телефон должен иметь 10 цифр и начинаться с 0",
"text_phys":"грн / мес",
"text_price_discount":"Экономите",
"text_price_total":"Итого",
"text_products":"товаров",
"text_public_offer":"публичной оферты",
"text_quantity_few":"Заканчивается",
"text_rating":"Рейтинг",
"text_reference":"Справка",
"text_removed_product":"Удален не существующий товар ",
"text_review_add":"Добавить отзыв",
"text_search":"Поиск",
"text_shipping_modal_text":"<p>Текст-заглушка о сроках отгрузки и способах доставки. Замените его в админке.</p>",
"text_shipping_modal_title":"Отгрузка в течение 24 часов",
"text_sort":"Сортировать",
"text_success_cashback":"Мы благодарны за выбор наших товаров и хотим доставить вам удовольствие в виде <b>кэшбека</b> за этот заказ",
"text_success_details":"Детальнее здесь",
"text_success_text":"Если у Вас возникли вопросы, пожалуйста <a href=\"%s\">свяжитесь с нами</a>. Спасибо за покупки в нашем интернет-магазине!",
"text_success_text1":"Ваш заказ <b>#{order_id}</b> успешно оформлен.<br>Менеджер позвонит по телефону для подтверждения в ближайшее время.",
"text_success_title1":"Спасибо за заказ",
"text_success_title2":"Прекрасный выбор",
"text_telephone":"Телефон",
"text_telephone_notice":"Введите номер для быстрого оформления",
"text_title_ii":"«Мгновенная рассрочка»",
"text_title_pp":"«Оплата частями»",
"text_to":"до",
"text_total":"Стоимость",
"text_total_payment":"Сумма платежа",
"text_uah_per_month":"грн/мес",
"text_val_format":"Неверный формат",
"text_val_max":"Максимум %s символов",
"text_val_min":"Минимум %s символов",
"text_val_required":"Обязательное поле",
"text_val_value":"Неверное значение",
"text_warranty":"гарантии",
"text_warranty_modal_text":"<p>Текст-заглушка об условиях гарантии и сервисного обслуживания. Замените его в админке.</p>",
"text_warranty_modal_title":"Гарантия и сервис",
"text_weight_unit":"кг",
"text_wish_products":"Понравившиеся товары",
"text_write":"Отправить отзыв",
"text_year1":"год",
"text_year2":"года",
"text_year3":"года",
"text_year4":"года",
"text_year5":"лет",
"wayforpay_applepay_description":"Платеж происходит мгновенно, удобный способ оплаты для владельцев iPhone либо Apple Watch",
"wayforpay_applepay_title":"Apple Pay",
"wayforpay_card_description":"",
"wayforpay_card_title":"Оплата картой",
"wayforpay_googlepay_description":"Платеж происходит мгновенно, удобный способ оплаты для владельцев с устройствами с Android",
"wayforpay_googlepay_title":"Google Pay",
"wayforpay_paypartsabank_description":"Оплата частями для владельцев карточек А-Банка. Комиссия 0%. Возможное количество частей: 2, 3, 4, 5.",
"wayforpay_paypartsabank_title":"Оплата частями А-Банк",
"wayforpay_paypartsmono_description":"Оплата частями для владельцев карточек Монобанка. Комиссия 0%. Возможное количество частей: 3, 4, 5.",
"wayforpay_paypartsmono_title":"Оплата частями Монобанк",
"wayforpay_paypartsotp_description":"Оплата частями для владельцев карточек OTP Банка. Комиссия 0%. Возможное количество частей: 3, 4.\r\nМинимальная сумма для покупки частями 300 грн",
"wayforpay_paypartsotp_title":"Оплата частями OTP",
"wayforpay_paypartsprivat_description":"Оплата частями для владельцев карточек Приватбанка. Комиссия 0%. Возможное количество частей: 2, 3 ,4.",
"wayforpay_paypartsprivat_title":"Оплата частями ПриватБанк",
"wayforpay_paypartspumb_description":"Оплата частями для владельцев карточек ПУМБ. Комиссия 0%. Возможное количество частей: 3, 4, 5.",
"wayforpay_paypartspumb_title":"Оплата частями ПУМБ",
"wayforpay_privat24_description":"Возможность совершить платеж через приложение Приват24",
"wayforpay_privat24_title":"Оплата в Приват24"
};

})();